import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import PaymentTermsModal from '../../../../components/Purchasing/VendorQuotes/PaymentsTerms/PaymentTermsModal'
import { Button } from 'antd'

PaymentTerms.propTypes = {}

function PaymentTerms(props) {
  const { fetch, fetching, list, onShow, isUpdatable } = props
  const [columns] = React.useState(() => [
    {
      Header: 'No',
      accessor: 'no',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Due Days', accessor: 'due.days' },
    { Header: 'Due Type', accessor: 'due.type' },
    {
      Header: 'Percentage',
      accessor: 'percentage',
      Cell: ({ value }) => value && `${value}%`,
    },
  ])

  return (
    <>
      <PaymentTermsModal {...props} />
      <CustomTable
        CreateButton={() => (
          <Button
            type={'primary'}
            size="small"
            icon={'plus'}
            onClick={onShow}
            disabled={!isUpdatable}>
            New
          </Button>
        )}
        fetch={fetch}
        data={list}
        fetching={fetching}
        columns={columns}
      />
    </>
  )
}

export default PaymentTerms
